<template>
    <div class="container">
        <div class="field_wrapper">
        <van-row class="field_row">
            <van-col span="3" class="icon_image">
                <img :src="props.leftImage" alt="">
            </van-col>
            <van-col span="11" class="label">{{ props.labelText }}
            </van-col>
            <van-col span="10" class="content">
                {{ props.content }}
            </van-col>
        </van-row>
    </div>
</div>
</template>

<script setup lang="ts">
import { } from 'vue'

const props = defineProps({
    labelText: {
        type: String,
        default: ''
    },
    leftImage: {
        type: String,
    },
    content: {
        type: String,
    },
})

</script>
<style scoped>
.container {
    background: #101629;
    padding: 5px 0px;
}

.field_wrapper {
  background: #101629;
  padding: 0px 10px;
}

.field_row {
  height: 55px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05); 
  background: transparent;
  height: 55px;
  display: flex;
}

.container:last-child .field_row {
  border-bottom: none !important;
}

.icon_container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.row_icon {
  width: 20px;
  opacity: 0.8; 
}

.label {
  font-size: 12px;
  font-weight: 500;
  color: #ffffff;
  display: flex;
  align-items: center;
}

.content.is_action {
  color: #7fa4c7;
  cursor: pointer;
}

.icon_image {
    display: flex;
    align-items: center;
    justify-content: center;
}

.icon_image img {
    width: 18px;
}

.content {
    display: flex;
    align-items: center;
    justify-content: right;
    padding: 0px 15px;
    font-size: 12px;
    color: #b9d1ff;
}

@media (min-width: 768px) {
  .label {
    font-size: 16px; 
  }

  .content {
    font-size: 15px; 
  }
}
</style>